import axios from "axios";
import BASE_URL from "@/services/baseUrl";
import router from "@/router";
import { clearSession } from "@/services/session.service";

const API_SECRET = process.env.VUE_APP_API_SECRET;

const clientAuthApi = axios.create({
  baseURL: `${BASE_URL}/bridge/api/v1/client-auth`,
});

clientAuthApi.interceptors.request.use((config) => {
  if (API_SECRET) {
    config.headers["X-API-Secret"] = API_SECRET;
  }
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

clientAuthApi.interceptors.response.use(
  (res) => res,
  async (err) => {
    const { response } = err;

    if (response && response.status === 401) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("client_id");
      clearSession();
      if (router.currentRoute.value.name !== "login") {
        router.push({ name: "login" });
      }
    }

    return Promise.reject(err);
  }
);

export const register = async ({ email, password, first_name, last_name }) => {
  try {
    const { data } = await clientAuthApi.post("/register/", {
      email,
      password,
      first_name,
      last_name,
    });
    return { isError: false, responseData: data };
  } catch (error) {
    return { isError: true, error };
  }
};

export const verifyOtp = async ({ email, code }) => {
  try {
    const { data } = await clientAuthApi.post("/verify/", { email, code });
    if (data._success === false) {
      return {
        isError: true,
        error: { message: data.message || "Invalid code" },
      };
    }
    return { isError: false, responseData: data };
  } catch (error) {
    return { isError: true, error };
  }
};

export const loginEmail = async ({ email, password }) => {
  try {
    const { data } = await clientAuthApi.post("/login/", { email, password });
    return { isError: false, responseData: data };
  } catch (error) {
    return { isError: true, error };
  }
};

export const forgotPassword = async ({ email }) => {
  try {
    const { data } = await clientAuthApi.post("/forgot-password/", { email });
    return { isError: false, responseData: data };
  } catch (error) {
    return { isError: true, error };
  }
};

export const resetPassword = async ({ email, code, password }) => {
  try {
    const { data } = await clientAuthApi.post("/reset-password/", {
      email,
      code,
      password,
    });
    return { isError: false, responseData: data };
  } catch (error) {
    return { isError: true, error };
  }
};

export const getProfile = async () => {
  try {
    const { data } = await clientAuthApi.get("/profile/");
    return { isError: false, responseData: data };
  } catch (error) {
    return { isError: true, error };
  }
};

export const getGoogleAuthUrl = (redirectUrl) => {
  const params = new URLSearchParams();
  if (redirectUrl) {
    params.set("redirect_url", redirectUrl);
  }
  return `${BASE_URL}/bridge/api/v1/client-auth/google/?${params.toString()}`;
};

export const getAppleAuthUrl = (redirectUrl) => {
  const params = new URLSearchParams();
  if (redirectUrl) {
    params.set("redirect_url", redirectUrl);
  }
  return `${BASE_URL}/bridge/api/v1/client-auth/apple/?${params.toString()}`;
};
